/**
 * This component just glues the redux-forms and react-bootstrap form
 * implementations together
 * https://github.com/react-bootstrap/react-bootstrap/issues/2210#issuecomment-246933578
 */
import React, { Component } from 'react';
import Alert from 'react-bootstrap/lib/Alert';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import classnames from 'classnames/bind';

import styles from './styles.sass';

const cx = classnames.bind(styles);

class FieldFormGroup extends Component {
  // set fields in redux store if they have been auto-filled by the browser
  // https://medium.com/@dschmidt1992/auto-fill-with-redux-forms-9b51ad8ef962#.bajzo0rex
  componentDidMount() {
    const { input } = this.props;
    input.onChange(this.inputField.value);
  }

  render() {
    const {
      children,
      componentClass,
      className,
      input,
      inputBsClass,
      maxLength,
      meta: { error, touched, submitFailed },
      name,
      onInputChange,
      placeholder,
      readOnly,
      rows,
      showFieldLevelError,
      type,
    } = this.props;
    const inputProps = {
      inputRef: node => {
        this.inputField = node;
      },
      bsClass: inputBsClass,
      name,
      onBlur: input.onBlur,
      onChange: e => {
        input.onChange(e);
        onInputChange && onInputChange(e);
      },
      placeholder,
      readOnly,
      rows,
      value: input.value,
    };
    if (componentClass) {
      inputProps.componentClass = componentClass;
    }
    if (type) {
      inputProps.type = type;
    }
    return (
      <div
        className={`FieldFormGroup ${cx({
          withFieldLevelError: showFieldLevelError,
        })} ${className || ''}`}
      >
        <FormGroup
          controlId={input.name}
          validationState={touched && error ? 'error' : null}
          bsSize="large"
        >
          {children && <ControlLabel>{children}</ControlLabel>}
          {showFieldLevelError && touched && error && (
            <Alert bsStyle="danger">{error}</Alert>
          )}
          <FormControl {...inputProps} />
          {!showFieldLevelError && touched && <FormControl.Feedback />}
          {maxLength && (
            <span
              className={`text-muted pull-right ${
                maxLength - input.value.length === 0 ? 'text-danger' : ''
              } ${styles.maxLengthLabel}`}
            >
              {`${input.value.length}/${maxLength}`}
            </span>
          )}
        </FormGroup>
        {submitFailed ? <span>{error}</span> : null}
      </div>
    );
  }
}

export default FieldFormGroup;
